import React from 'react'
import { Badge } from '@contrast-security-inc/design-system-badges'
import { css } from '@emotion/css'
import { useIntl } from 'react-intl'

export function NewRuleBadge() {
  const { formatMessage } = useIntl()

  return (
    <Badge
      color="neutral90"
      className={css`
        font-size: 9px;
        border-radius: 10px;
        padding: 0px 7px;
        min-width: auto;
        font-weight: 700;
      `}
    >
      {formatMessage({ id: 'title_newRule' })}
    </Badge>
  )
}
